import { render, staticRenderFns } from "./UsageRoutesTable.vue?vue&type=template&id=68414d1f&scoped=true"
import script from "./UsageRoutesTable.vue?vue&type=script&lang=js"
export * from "./UsageRoutesTable.vue?vue&type=script&lang=js"
import style0 from "./UsageRoutesTable.vue?vue&type=style&index=0&id=68414d1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68414d1f",
  null
  
)

export default component.exports